import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CiTwoToneSvg from "@ant-design/icons-svg/es/asn/CiTwoTone";
import AntdIcon from "../components/AntdIcon";
var CiTwoTone = function CiTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CiTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CiTwoTone.displayName = 'CiTwoTone';
}
export default /*#__PURE__*/React.forwardRef(CiTwoTone);